function map_query( query = {}) {
    let url = ''
    if (Object.keys(query).length > 0) {
        for (const [key, value] of Object.entries(query)) {
            if (
                Array.isArray(value)
            ) {
                for (const [index, val] of Object.entries(value)) {
                    if (Object.keys(val).length > 0) {
                        for (const [key_, value_] of Object.entries(val)) {
                            url += (`${key}[${index}][${key_}]=${value_}&`)
                        }
                    } else {
                        url += (`${key}[${index}]=${val}&`)
                    }
                }
            } else {
                url += (`${key}=${value}&`)
            }
        }
        url = url.slice(0,-1)
    }
    return `?${url}`
}
export {
    map_query
}